import { SocialEmbedCard } from 'components/card/SocialEmbedCard/social-embed-card'

interface YouTubeCardProps {
  embedCode: string
  url: string
}

const platform = 'youtube'
const logoSrc =
  '//images.babylist.com/image/upload/v1667413263/logos/youtube.png'
const YouTubeCard = ({ embedCode, url }: YouTubeCardProps) => (
  <SocialEmbedCard
    embedCode={embedCode}
    logoSrc={logoSrc}
    platform={platform}
    url={url}
  />
)

export default YouTubeCard
